class DetailsDisclosure extends HTMLElement {
  connectedCallback() {
    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("click", this.toggle);
    this.addEventListener("keyup", this.onKeyUpEscape);

    // Listen for clicks anywhere in the document
    document.addEventListener("click", this.onDocumentClick);
  }

  disconnectedCallback() {
    // Clean up global event listener
    document.removeEventListener("click", this.onDocumentClick);
  }

  toggle = (event) => {
    const summaryElement = this.querySelector("summary");
    if (summaryElement.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      if (!this.mainDetailsToggle.hasAttribute("open")) {
        this.open();
      } else {
        this.close();
      }
    }
  };

  open() {
    document.querySelectorAll("details-disclosure").forEach((element) => {
      if (element !== this) {
        element.close();
      }
    });

    this.mainDetailsToggle.setAttribute("open", "");
    this.updateOverlayDisplay();
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.updateOverlayDisplay();
  }

  onKeyUpEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  onDocumentClick = (event) => {
    if (!this.contains(event.target)) {
      this.close();
    }
  };

  updateOverlayDisplay() {
    const overlay = document.getElementById("custom-nav-overlay");
    const anyOpen = document.querySelectorAll("details-disclosure > details[open]").length > 0;
    if (anyOpen) {
      overlay.classList.add("showOverlay");
    } else {
      overlay.classList.remove("showOverlay");
    }
  }
}

customElements.define("details-disclosure", DetailsDisclosure);
